import axios from "../axiosInstance"

class LoginService {
	async autenticarUsuario(idSessao, opcoes) {
		return await axios.get("/autenticacao/" + idSessao, opcoes)
	}

	async autenticar(login, senha) {
		return await axios.post('/autenticacao/convenios', {
			login: login,
			senha: senha
		});
	}

	async autenticarComLaboratorio(login, senha, codigoLaboratorio, idSessao) {
		return await axios.post('/autenticacao/validacao', {
			login: login,
			senha: senha,
			codigoLaboratorio: codigoLaboratorio,
			idSessao: idSessao
		});
	}

	async trocarLaboratorioUsuario(codigoLaboratorio) {
		return await axios.get("trocarLaboratorio/" + codigoLaboratorio);
	}
}

export default new LoginService()
